import { render } from "./addpurchaseinvoice.vue?vue&type=template&id=2d08f35e&scoped=true"
import script from "./addpurchaseinvoice.vue?vue&type=script&lang=js"
export * from "./addpurchaseinvoice.vue?vue&type=script&lang=js"

import "./addpurchaseinvoice.vue?vue&type=style&index=0&id=2d08f35e&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d08f35e"]])

export default __exports__